"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UtilityButtonTertiaryInline = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _base = _interopRequireDefault(require("@emotion/styled/base"));
var _react = _interopRequireDefault(require("react"));
var _utils = require("@amzn/stencil-design-tokens/js/web/utils");
var _constants = require("../button/constants");
var _button = require("../button");
var _constants2 = require("./constants");
var _react2 = require("@emotion/react");
const color = (0, _utils.token)('color.link.neutral-default');
const StyledUtilityButtonTertiaryInline = /*#__PURE__*/(0, _base.default)(_button.Button, process.env.NODE_ENV === "production" ? {
  target: "e1jnxsg30"
} : {
  target: "e1jnxsg30",
  label: "StyledUtilityButtonTertiaryInline"
})(_ref => {
  let {
    disabled,
    'aria-disabled': ariaDisabled,
    icon,
    children
  } = _ref;
  const iconOnly = !!icon && !children;
  let iconOnlyStyles = {};
  if (iconOnly) {
    iconOnlyStyles = {
      ':hover': {
        color: (0, _utils.token)('color.icon.primary-hover'),
        backgroundColor: (0, _utils.token)('color.action.utility.bg-hover')
      },
      ':active': {
        color: (0, _utils.token)('color.icon.primary-pressed'),
        backgroundColor: (0, _utils.token)('color.action.utility.bg-pressed')
      }
    };
  }
  if (disabled) {
    return {
      color: _constants2.DISABLED_TEXT_COLOR
    };
  }
  if (ariaDisabled) {
    return {
      color: _constants.ARIA_DISABLED_TEXT_COLOR
    };
  }
  return {
    color,
    ':hover': {
      color: (0, _utils.token)('color.link.neutral-hover')
    },
    ':active': {
      color: (0, _utils.token)('color.link.neutral-pressed')
    },
    ...(iconOnly && iconOnlyStyles)
  };
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
const UtilityButtonTertiaryInline = exports.UtilityButtonTertiaryInline = /*#__PURE__*/_react.default.forwardRef((_ref2, ref) => {
  let {
    children,
    hasUnderline,
    ...props
  } = _ref2;
  return (0, _react2.jsx)(StyledUtilityButtonTertiaryInline, (0, _extends2.default)({
    variant: hasUnderline ? _button.ButtonVariant.TertiaryInlineWithUnderline : _button.ButtonVariant.TertiaryInline,
    ref: ref
  }, props), children);
});